import { useEffect, useState } from 'react'

/**
 * @name useIsClient
 * @description A React hook that checks if the window object is present.
 * @returns {boolean}
 */

export function useIsClient() {
  const [isClient, setClient] = useState(false)

  useEffect(() => {
    setClient(true)
  }, [])

  return isClient
}
